import { atomWithKey as atom } from "./atomWithKey";
import { ICmsNetworkMapStations } from "../Types/Index";

export const journeyPlannerStationAtom = atom<ICmsNetworkMapStations[]>({
  key: "journeyPlannerStationAtom",
  default: [],
});
